import React, { Component } from 'react';
import { translate } from '../Services/translation';

class WishList extends Component {
    constructor(props) {
        super(props);
    }

    handleAddToCart(articleNumber, quantity) {
        this.props.onAddToCart(articleNumber, quantity);
    }

    handleRemoveItem(sortIndex) {
        this.props.onRemoveItem(sortIndex);
    }

    render() {
        return (
            <div className="wishlist__content__item__container">
                {this.props.wishList &&
                    Object.keys(this.props.wishList).length < 1 && (
                        <div className="wishlist__content__item__container__empty">
                            <p>{translate('wishlist.empty')}</p>
                        </div>
                    )}
                {this.props.wishList &&
                    this.props.wishList.map((item, index, array) => (
                        <div key={`wishlist-item-${index}`}>
                            <div className="wishlist__content__item">
                                <img
                                    className="wishlist__content__item__product-image"
                                    src={item.image}
                                    alt={item.name}
                                />

                                <div className="wishlist__content__item__product-info">
                                    <div className="wishlist__content__item__product-info__item">
                                        <div className="wishlist__content__item__product-info__item__info">
                                            <p className="wishlist__content__item__product-info__item__info__title">
                                                {item.name}
                                            </p>
                                            {item.size && (
                                                <p className="wishlist__content__item__product-info__item__info__variant">
                                                    <p>
                                                        {translate(
                                                            'wishlist.size'
                                                        )}
                                                        : {item.size}
                                                    </p>
                                                </p>
                                            )}
                                        </div>
                                        {item.reducedPrice ? (
                                            <p className="wishlist__content__item__product-info__item__price--discount">
                                                {item.reducedPrice}
                                            </p>
                                        ) : (
                                            <p className="wishlist__content__item__product-info__item__price">
                                                {item.price}
                                            </p>
                                        )}
                                    </div>
                                    <div className="wishlist__content__item__product-info__item">
                                        <a
                                            className="wishlist__content__item__product-info__item__delete"
                                            onClick={(event) =>
                                                this.handleRemoveItem(
                                                    item.sortIndex
                                                )
                                            }
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {translate('wishlist.delete')}
                                        </a>
                                        <button
                                            className="button wishlist__content__item__product-info__item__cart-button"
                                            onClick={() => 
                                                this.handleAddToCart(
                                                    item.articleNumber,
                                                    1
                                                )
                                            }
                                        >
                                            {translate('wishlist.addtocart')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        );
    }
}

export default WishList;
